"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var UULogoWithText = function UULogoWithText(props) {
  var color = props.color,
    id = props.id,
    height = props.height,
    width = props.width,
    style = props.style;
  var icon = _constants.ICONS.LogoShieldText;
  var iconImage = (0, _lodash.get)(icon, 'markup', null);
  var viewBox = (0, _lodash.get)(icon, 'viewBox', null);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-logo-with-text",
    id: id,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: "ui-logo-with-text__icon",
    height: height,
    width: width,
    viewBox: viewBox,
    fill: color
  }, iconImage));
};
UULogoWithText.propTypes = {
  /** color of logo */
  color: _propTypes["default"].string,
  /** id for reference */
  id: _propTypes["default"].string,
  /** height of UULogoWithText image.<br/>
   * **NOTE:** if both height and width are supplied,
   * the smaller number of the two will take precedence.
   * The image will automatically calculate aspect ratio.
  */
  height: _propTypes["default"].number,
  /** width of UULogoWithText image.<br/>
   * **NOTE:** if both height and width are supplied,
   * the smaller number of the two will take precedence.
   * The image will automatically calculate aspect ratio.
  */
  width: _propTypes["default"].number,
  /** Override the inline-styles of the UULogoWithText || **Not Recommended** */
  style: _propTypes["default"].object
};
UULogoWithText.defaultProps = {
  color: '#2C405A',
  id: '',
  height: null,
  width: null,
  style: {}
};
var _default = exports["default"] = UULogoWithText;